import { render, staticRenderFns } from "./GestioneAttivitaModuliListPage.vue?vue&type=template&id=7775e7f4"
import script from "./GestioneAttivitaModuliListPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaModuliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports